import { ReactNode } from 'react';
import { ToggleLocation } from './constants';

export const getToggleButtons = ({
    button,
    shouldTruncateContent,
    toggleLocation = ToggleLocation.bottom,
}: {
    button: ReactNode;
    shouldTruncateContent: boolean;
    toggleLocation?: ToggleLocation;
}) => {
    if (!shouldTruncateContent) {
        return {
            topButton: null,
            bottomButton: null,
        };
    }

    return toggleLocation === ToggleLocation.top
        ? {
              topButton: button,
              bottomButton: null,
          }
        : {
              topButton: null,
              bottomButton: button,
          };
};
